import React from 'react'
import styled from 'styled-components'
import Mailchimp from 'react-mailchimp-form'

const Newsletter = () => {
  return (
    <Wrapper>
      <h2>Want to stay up to date with what's new?</h2>
      <p>
        Sign up for our bi-monthly newsletter to keep up to date with new
        features, design releases and featured solutions!
      </p>
      <Mailchimp
        className="mailchimp-form"
        action="https://gmail.us18.list-manage.com/subscribe/post?u=937e13c8159b8a6964e7ad0af&amp;id=be8e667045"
        fields={[
          {
            name: 'EMAIL',
            placeholder: 'Email',
            type: 'email',
            required: true,
            className: 'mailchimp-input',
          },
        ]}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #e5e2fd;
  padding: 50px 12px;
  h2 {
    font-size: 30px;
  }
  .mailchimp-form input {
    padding: 5px 12px;
    border: none;
    border-radius: 5px 0 0 5px;
    /* display: none; */
    /* margin-right: 12px; */
  }
  .mailchimp-form button {
    padding: 5px 12px;
    border: none;
    border-radius: 0 5px 5px 0;
    background-color: #efefef;
  }
  /* @media (min-width: 768px) {
    padding: 25px;
  } */
  @media (min-width: 900px) {
    padding: 50px 25px;
    h2 {
      font-size: 48px;
    }
  }
`

export default Newsletter
